import { nonce, shadow } from '../assets/scripts/constants';
// Common for all requests.
const baseProductId = process.env.REACT_APP_BASE_PRODUCT_ID || 4440;
const apiHost = process.env.REACT_APP_API_HOST || 'eclisse.muotolevy.fi';

/**
 * Gets current sliding door product variations from WooCommerce
 *
 * @deprecated 0.1.0 No need to get existing variations.
 *
 * @returns {object} Error and Variations info.
 */
export const getVariations = async () => {
  let variations = [];
  let i = 0;
  const perPage = 100;
  const headers = new Headers();
  while (true) {
    i += 1;
    // Disabled because this needs to be done one request at a time
    // eslint-disable-next-line no-await-in-loop
    const response = await fetch(
      `https://${apiHost}/wp-json/wc/v2/products/${baseProductId}/variations?per_page=${perPage}&page=${i}&${shadow}`,
      {
        headers,
        credentials: 'same-origin',
      }
    );
    if (response.status !== 200) {
      throw new Error('Failed to get variations');
    }
    // Disabled because this needs to be done one request at a time
    // eslint-disable-next-line no-await-in-loop
    const additions = await response.json();
    variations = variations.concat(additions);
    if (additions.length < perPage) {
      break;
    }
  }
  return variations;
};

/**
 * Creates a variation in WooCommerce
 *
 * Sends a nonce (sort-of) and the selected attributes
 * to WP REST API, which internally creates a product
 * variation based on them. Returns the ID of the
 * created variation
 *
 * @param   {object} config Data User's configuration.
 * @returns {int}           Created variation's ID.
 */
export const createVariation = async configData => {
  const attributes = Object.keys(configData).filter(
    attribute => attribute.substr(0, 3) === 'pa_'
  );
  const postAttributes = attributes.map(attribute => ({
    name: attribute,
    option: configData[attribute].value,
  }));
  const postData = {
    attributes: postAttributes,
    nonce,
  };
  const headers = new Headers();
  headers.set('content-type', 'application/json');
  const response = await fetch(
    `https://${apiHost}/wp-json/eclisse/v1/configure?${shadow}`,
    {
      method: 'POST',
      headers,
      body: JSON.stringify(postData),
      credentials: 'same-origin',
    }
  );
  if (response.status !== 201) {
    throw new Error('Failed to create new variation');
  }
  const variationId = await response.json();
  return variationId;
};

/**
 * Adds product to WooCommerce cart.
 *
 * @param {object} configData  Current config data.
 * @param {string} variationId WC variation ID.
 * @returns {undefined}
 */
export const addToCart = async (configData, variationId) => {
  const quantity = (configData.quantity && configData.quantity.value) || 1;
  // Build variation attributes.
  const variation = Object.keys(configData).reduce((attributes, attr) => {
    if (attr.startsWith('pa_')) {
      attributes[`attribute_${attr}`] = configData[attr].value; // eslint-disable-line no-param-reassign
    }
    return attributes;
  }, {});
  const headers = new Headers();
  headers.set('content-type', 'application/json');
  const postData = {
    product_id: baseProductId,
    variation_id: variationId,
    quantity,
    variation,
  };
  const response = await fetch(
    `https://${apiHost}/wp-json/eclisse/v1/add-to-cart?${shadow}`,
    {
      method: 'POST',
      headers,
      body: JSON.stringify(postData),
      credentials: 'include',
    }
  );
  if (response.status !== 200) {
    throw new Error('Failed to add to cart');
  }
  return true;
};

/**
 * Sends a request to delete old variations
 *
 * Doesn't stick around and wait for a response, just
 * optimistically send the request.
 */
export const maybeDeleteOldVariations = () => {
  const postData = {
    nonce,
  };
  const headers = new Headers();
  headers.set('content-type', 'application/json');
  fetch(`https://${apiHost}/wp-json/eclisse/v1/sync?${shadow}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(postData),
    credentials: 'same-origin',
  });
};

export const getTax = async () => {
  const apiUrl = `https://${apiHost}/wp-json/wc/v2/taxes`;
  // const devTax = process.env.REACT_APP_DEV_TAX;
  const basicAuthHash = process.env.REACT_APP_BASIC_AUTH_HASH;

  // if (devTax) {
  //   return Number(devTax);
  // }

  if (!basicAuthHash) {
    throw new Error('fetchConfig: Missing basic auth hash.');
  }

  const headers = new Headers();
  headers.append('Authorization', `Basic ${basicAuthHash}`);

  // Fetch taxes
  let taxes = await fetch(`${apiUrl}?${shadow}`, {
    method: 'GET',
    headers,
    credentials: 'same-origin',
  });

  if (taxes.status && taxes.ok) {
    taxes = await taxes.json();
    if (taxes[0]) {
      let { rate: tax } = taxes[0];
      tax = Number.parseFloat(tax);
      tax = Number.isFinite(tax) ? tax : 0;
      return tax;
    }
  }

  return 0;
};



// WEBPACK FOOTER //
// ./src/services/api.service.js